import Vue from 'www/vue_components'

import { getBooleanFromString } from 'www/utils'

import { BLOCK_NAME } from 'www/diagnostika.mobile.blocks/b-services-mobile/b-services-card/constants'

import {
  CLUB_SELECTORS,
  CLUB_DATA_STORE,
} from 'www/diagnostika.mobile.blocks/b-services-mobile/b-services-card/modules/ServicesClubLogic/constants'

export const destroyComponents = arr => arr.forEach(vm => vm.$destroy())

export const renderComponent = (node, props = {}, component = undefined) => {
  if (!node) {
    return
  }

  node.innerHTML = '<div id="node-id"></div>'

  return new Vue({
    el: node.querySelector('#node-id'),
    render: h => h(component, { props }),
  })
}

export const getPropsFromHTML = nodeList => (
  nodeList.map(node => ({
    node,
    props: JSON.parse(node.getAttribute(CLUB_DATA_STORE.componentContextProps) || null),
  }))
)

export const getNodesData = () => {
  const nodesData = {
    mountModalInfoNode: document.querySelector(CLUB_SELECTORS.modalMount),
    mountServiceDiscountControlNodeList: [...document.querySelectorAll(CLUB_SELECTORS.serviceDiscountControlMount)],
    mountBannerDetailNode: document.querySelector(CLUB_SELECTORS.infoDetailBannerMount),
    lpuCards: [...document.querySelectorAll(`.${BLOCK_NAME}`)],
  }

  nodesData.lpuCardsPriceListNodes = nodesData.lpuCards.map(card => ({
    priceListNodesClub: card.querySelectorAll(CLUB_SELECTORS.priceWithDiscount),
    priceListNodesDefault: card.querySelectorAll(CLUB_SELECTORS.priceWithoutDiscount),
  }))

  return nodesData
}

export const getIsEnabledLpuClub = target => getBooleanFromString(target.closest(`[${CLUB_DATA_STORE.isEnabledLpu}]`)?.getAttribute(CLUB_DATA_STORE.isEnabledLpu))
